import { printTypesForDeliveryETA } from '@/model/printType/printTypesForDeliveryETA';
import { getCurrentAppearance } from '@/redux/draft/getters/getCurrentAppearance';
import { getPrintAreaForNewConfiguration } from '@/redux/draft/getters/getPrintAreaForNewConfiguration';
import { selectConfigurations } from '@/redux/draft/getters/selectConfigurations';
import { StoreState } from '@/redux/types';

const getPrintTypeIdsForDraft = (state: StoreState) => {
  return [...new Set<string>(selectConfigurations(state).map(({ printType }) => printType.id))];
};

export const getPrintTypeIdsForDeliveryETA = (state: StoreState) => {
  const printTypeIdsForDraft = getPrintTypeIdsForDraft(state);

  if (printTypeIdsForDraft.length) {
    return printTypeIdsForDraft;
  }

  const appearance = getCurrentAppearance(state);
  const printArea = getPrintAreaForNewConfiguration(state);

  return printTypesForDeliveryETA(printArea, appearance);
};
